<template>
  <div class="container" style="margin-top:50px;">
    <div class="row">
      <div
        v-for="item in $store.state.dataProducts"
        :key="item.id"
        @click="detailProduct(item.id)"
        class="col-sm-2"
        style="margin-bottom: 50px; "
      >
        <div class="border shadow-sm rounded">
          <div class="rounded">
            <img style="width: 157px; height: 100px;" :src="item.image_url" />
          </div>
          <div class="card-body" style="border-style: none; min-height:110px; max-height:110px;">
            <p
              style="font-size:14px; text-align: left;  font-weight: bold; min-height:50px; max-height:50px; margin: 0; padding: 0;"
            >{{nameProduct(item.name)}}</p>
            <p
              style="font-size:14px; text-align: left; color:#FA591D;  padding: 0;"
            >{{price(item.price)}}</p>
          </div>
          <div class="card" style></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    detailProduct(id) {
      console.log("wkwkwk", id);
      this.$store.dispatch("detailProduct", id);
    },
    price(angka) {
      var rupiah = "";
      var angkarev = angka
        .toString()
        .split("")
        .reverse()
        .join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return (
        "Rp. " +
        rupiah
          .split("", rupiah.length - 1)
          .reverse()
          .join("")
      );
    },
    nameProduct(str) {
      let length = 30;
      let ending;
      if (length == null) {
        length = 100;
      }
      if (ending == null) {
        ending = "...";
      }
      if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
      } else {
        return str;
      }
    }
  },
  created() {
    this.$store.dispatch("readProduct");
  }
};
</script>

<style></style>
